/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(function(){

    AOS.init({
        duration: 1200, 
        once: true
      });
      
    var HeadingTabbers = $('.HeadImage__tabbers .Linklist__Item');
    HeadingTabbers.on('mouseenter', function(){
        var me = $(this),
            image_target = me.data('image-target'),
            imageElemWrap = $('.HeadImage__switcher'),
            menuTabsElemWrap = $('.menuTabs'),
            imageElemAll = imageElemWrap.children('.MegaMenu__Push'),
            imageElemTarget = imageElemWrap.find('[data-id="'+image_target +'"'),
            menuTabsElemTarget = $('.menuTabs[data-line="'+image_target +'"]');

            $('.HeadImage__tabbers > .Linklist__Item').removeClass('active');
            me.addClass('active');

            menuTabsElemWrap.removeClass('active');
            menuTabsElemTarget.addClass('active');

            imageElemAll.not('[data-id="'+image_target +'"]').hide();
            imageElemAll.removeClass('active__image');
            imageElemTarget.addClass('active__image').fadeIn();
            console.log(image_target);
     });
     

    var HeadingTabbers = $('.menuTabs .Linklist__Item');
    HeadingTabbers.on('mouseenter', function(){
        var me = $(this),
            image_target = me.data('img');

            $('.active__image img').attr('src', image_target);
     });
     $('.Footer__Block--links .Footer__Title').on('click', function(){
         
        $(this).toggleClass('active');
        $(this).next().slideToggle();
     });
 

     $('.ProductCollectionItem').each(function(){
         var parent = $(this);
         
         parent.find('.ColorSwatchTab--item').on('click', function(){
            var self = $(this),
                tabs = parent.find('.ProductColorTabs'),
                active_class = 'is-active';
                activeTab = parent.find('.tab--'+ self.data('tag') +'');

            tabs.removeClass(active_class);
            activeTab.addClass(active_class);

            self.parent().parent().find('.ColorSwatchTab--item').removeClass(active_class);
            self.addClass(active_class);
            tabs.hide();
            activeTab.fadeIn();
        });
     });

     var ProductSelection = $('.ProductSelection');

     function SetSubscriptionToolbar(url){
        var ActiveSuscriptionProduct = $('.ProductSelection.active');

        if (ActiveSuscriptionProduct.length) {
            $('.SubscriptionProduct__Step').fadeIn();
            $('.SubscriptionProduct__Step').find('a').attr('href', url);
        }
     }

     ProductSelection.on('click', function(){
        ProductSelection.removeClass('active');
        $(this).addClass('active');

        SetSubscriptionToolbar($(this).find('.is-active').data('url'));
        console.log($(this).find('.is-active').data('url'));
     });


     $('.Select_Prescription, .Prescription_Popup .Drawer__Close').on('click', function(){
         var PrescriptionPopup = $('.Prescription_Popup'),
             PageOverlay = $('.PageOverlay');

         if (PrescriptionPopup.hasClass('opened')) {

         } else {
            PrescriptionPopup.attr('aria-hidden', 'false');
            PageOverlay.addClass('is-visible');
         }

     });


     $('.PageOverlay').on('click', function(){
        var PrescriptionPopup = $('.Prescription_Popup');
        $(this).removeClass('is-visible');
        PrescriptionPopup.attr('aria-hidden', 'true');
     });




    function LoadTheme__modules() {



        $('.Prescription_Popup .Drawer__Close').on('click', function(){
            
            var PrescriptionPopup = $('.Prescription_Popup'),
                PageOverlay = $('.PageOverlay');

            

            if (PrescriptionPopup.attr('aria-hidden') == "false") {

                PageOverlay.removeClass('is-visible');
                PrescriptionPopup.attr('aria-hidden', 'true');
            }
        });


        $('.SubscriptionStep3').on('click', function(){
            console.log('heu');
            var PrescriptionPopup = $('.Prescription_Popup'),
                PageOverlay = $('.PageOverlay');

            if (PrescriptionPopup.attr('aria-hidden') == "false") {

                PageOverlay.removeClass('is-visible');
                PrescriptionPopup.attr('aria-hidden', 'true');
            }

            $('.Step3').fadeIn();
        });

        $('.ProductForm--ajax').on('submit', function(e){
        var form = $(this),
            addToCartBtn = form.find('.ProductForm__AddToCart'),
            addToCartBtn_label = addToCartBtn.first('span').text(),
            btnAdding = 'Adding...',
            btnAdded = 'Product added!';
    
            addToCartBtn.first('span').text(btnAdding);
    
    
            jQuery.post('/cart/add.js',  form.serialize(), function(a){
        
                addToCartBtn.first('span').text(btnAdded);
                
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true
                })); 
        

                var PrescriptionPopup = $('.Prescription_Popup'),
                    PageOverlay = $('.PageOverlay');

                if (PrescriptionPopup.attr('aria-hidden') == "false") {

                    PageOverlay.removeClass('is-visible');
                    PrescriptionPopup.attr('aria-hidden', 'true');
                }

                setTimeout(() => {
                    addToCartBtn.first('span').text(addToCartBtn_label);

            
                    $('.Head--cart').click(function() {
                        // 'this' is not a jQuery object, so it will use
                        // the default click() function
                        this.click();
                    }).click();
                
                }, 1000);
        
                
            }, "json");
        
            e.preventDefault();
        });


        $('.SubscriptionForm').on('submit', function(e){
            var form = $(this),
                addToCartBtn = form.find('.ProductForm__AddToCart'),
                addToCartBtn_label = addToCartBtn.first('span').text(),
                btnAdding = 'Adding...',
                btnAdded = 'Product added!';
        
                addToCartBtn.first('span').text(btnAdding);
        
        
                jQuery.post('/cart/add.js',  form.serialize(), function(a){
            
                    addFakeProducts(function(){
                        addToCartBtn.first('span').text(btnAdded);
                    
                        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                            bubbles: true
                        })); 
                
        
                        var PrescriptionPopup = $('.Prescription_Popup'),
                            PageOverlay = $('.PageOverlay');
        
                        if (PrescriptionPopup.attr('aria-hidden') == "false") {
        
                            PageOverlay.removeClass('is-visible');
                            PrescriptionPopup.attr('aria-hidden', 'true');
                        }
        
                        setTimeout(() => {
                            addToCartBtn.first('span').text(addToCartBtn_label);
        
                    
                            $('.Head--cart').click(function(e) {
                                // 'this' is not a jQuery object, so it will use
                                // the default click() function
                                this.click();
                                e.preventDefault();
                            }).click();
                        
                        }, 500);
                    });


                    
            
                    
                }, "json");
            
                e.preventDefault();
            });


        function addFakeProducts(callback){
            var MainProduct = $('#product-main-variant');
            console.log(MainProduct.val());
             $.ajax({ type: 'POST',  url: '/cart/add.js',  dataType: 'json',  
                data: {id: 37616853483719, quantity: 1},
                success: function(a){
                    $.ajax({
                        type: 'POST', 
                        url: '/cart/add.js',
                        dataType: 'json', 
                        data: {id: MainProduct.val(), quantity: 1},
                        success: function(){
                            callback();
                        }
                     });
                },
                error: function(a){
                    console.log('error ', a);
                }
             });


             /**/
        }
    
    }
        
    
    document.addEventListener('theme:loading:end', function(event) {
        //LoadTheme__modules();
    
    });
    
    
    
    $(function(){
        LoadTheme__modules();
    });


    $('.Product__colorSelection').each(function(){


        $(this).slick({
            dots: false,
            arrows: true,
            infinite: false,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1
        });
    });

	$('.PageContent--Slider, .PageContent--Slider-featured').slick({
      dots: false,
      arrows:false,
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 641,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

    $(".okeReviews-reviewsSummary").click(function(){
        $(".okeReviews-widget-holder").addClass("visible");
        $('html, body').animate({scrollTop:0}, 'slow');
        return false;
    });

    $(".okeReviews-close").click(function(){
        $(".okeReviews-widget-holder").removeClass("visible");
    });


    $(".Link__Scroll").on('click', function () {
        var data_id = $(this).data('id');
        
        $('.Section').each(function() {
            var el = $(this);
            
            if
            (el.attr('id') == data_id)
            el.show();
            
            else
            el.show();
        });
        
        $('html, body').animate({
          scrollTop: $( '#' + data_id).offset().top - 170
        }, 'slow');
    });

     /**var mobileCurrency = setInterval(() => {
         var $currencyWrap = $('.SidebarMenu__CurrencySelector'),
             $cloneClone = $('.gep-switcher-desktop').clone();

        if ( $currencyWrap.hasClass('added')) {
            clearInterval(mobileCurrency);
        } else {
            if ( $('.gep-switcher-desktop').length > 0) {
                $currencyWrap.addClass('added');
                $currencyWrap.html($cloneClone);

                $cloneClone.on('click', function(){
                    $('.gep-switcher-desktop').click();
                });
            }
        }

     }, 500); */
 })